"use client";

import type { AboutData } from "@/services/public.service";

// content may contain rich HTML from the dashboard editor.
export default function AboutIntro({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const content = isAr ? about.content.ar : about.content.en;
  if (!content) return null;

  return (
    <section className="container mx-auto px-6 py-16 md:py-20">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block w-12 h-1 rounded-full bg-clay-600 mb-6" />
        <div
          className="prose prose-lg max-w-none text-ink-500 leading-loose [&_strong]:text-ink-900"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </section>
  );
}
